/**
 * Centralized Logger Utility for Frontend
 * Provides log levels: DEBUG, INFO, WARN, ERROR
 * Controlled by process.env.EXPO_PUBLIC_LOG_LEVEL (defaults to 'DEBUG')
 */

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
} as const;

type LogLevel = keyof typeof LOG_LEVELS;

const getLogLevel = (): number => {
  const envLevel = (process.env.EXPO_PUBLIC_LOG_LEVEL || 'DEBUG').toUpperCase() as LogLevel;
  if (envLevel && LOG_LEVELS.hasOwnProperty(envLevel)) {
    return LOG_LEVELS[envLevel];
  }
  return LOG_LEVELS.DEBUG;
};

const currentLogLevel = getLogLevel();

export const logger = {
  debug: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      // eslint-disable-next-line no-console
      console.log('[DEBUG]', ...args);
    }
  },

  info: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.INFO) {
      // eslint-disable-next-line no-console
      console.log('[INFO]', ...args);
    }
  },

  warn: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.WARN) {
      // eslint-disable-next-line no-console
      console.warn('[WARN]', ...args);
    }
  },

  error: (...args: unknown[]): void => {
    if (currentLogLevel <= LOG_LEVELS.ERROR) {
      // eslint-disable-next-line no-console
      console.error('[ERROR]', ...args);
    }
  },
};
